/**
 * Полоска «до бесплатной доставки» — нативная замена виджета Hextom Free Shipping Bar.
 *
 * Начальное значение приходит уже готовым из Liquid (мгновенно, без сдвига макета).
 * Этот скрипт нужен только чтобы пересчитать сумму после того,
 * как покупатель добавил/убрал товар без перезагрузки страницы.
 */
(function () {
  'use strict';

  var nodes = document.querySelectorAll('[data-shipping-bar]');
  if (!nodes.length) return;

  function formatMoney(cents, currency, locale) {
    var value = cents / 100;
    try {
      return new Intl.NumberFormat(locale || 'sk-SK', {
        style: 'currency',
        currency: currency || 'EUR',
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function render(node, totalCents) {
    var threshold = parseInt(node.getAttribute('data-threshold'), 10) || 0;
    var currency = node.getAttribute('data-currency');
    var locale = node.getAttribute('data-locale');

    var text;
    if (threshold > 0 && totalCents >= threshold) {
      // Порог достигнут
      text = node.getAttribute('data-text-reached');
    } else if (totalCents > 0) {
      // Что-то в корзине, но порог не достигнут
      var left = formatMoney(threshold - totalCents, currency, locale);
      text = (node.getAttribute('data-text-progress') || '').replace(/\[suma\]/g, '<strong>' + left + '</strong>');
    } else {
      // Корзина пуста
      text = node.getAttribute('data-text-empty');
    }

    if (text && node.innerHTML !== text) {
      node.innerHTML = text;
    }
  }

  function refresh() {
    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        nodes.forEach(function (node) { render(node, cart.total_price); });
      })
      .catch(function () { /* молча игнорируем — на экране останется прошлое значение */ });
  }

  // Небольшая задержка: даём Shopify дописать корзину до того, как спрашиваем сумму
  var timer = null;
  function scheduleRefresh() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  // 1) События самой темы
  if (window.eventBus) {
    ['cart:added', 'update:cart:drawer', 'render:cart:drawer', 'qty:change'].forEach(function (evt) {
      window.eventBus.on(evt, scheduleRefresh);
    });
  }

  // 2) Подстраховка: любой запрос к /cart/add|change|update — значит корзина изменилась
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      if (typeof url === 'object' && url !== null && url.url) url = url.url;
      var result = originalFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(scheduleRefresh).catch(function () {});
      }
      return result;
    };
  }

  // 3) Возврат на страницу из кэша браузера (кнопка «назад»)
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
})();
